






import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { AUTH_GET_CLIENT, AUTH_GET_COUNTRY } from '@/store/modules/authentication/types';
import { Client } from '@/store/modules/authentication/interfaces';
import { TupleDictionary } from '@/utils/tupleDictionary';
import { ClientEnum } from '@/enums/client.enum';
import { CountryEnum, CountryType } from '@/enums/country.enum';
import ReportPowerBiContainer from '@/modules/neodash/components/report-powerbi-container/report-powerbi-container.vue';
import { traceLogAccess } from '@/services';
import { ContextEnum } from '@/enums/context.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';

@Component({
  name: 'PbiDealerEvaluationPage',
  components: { ReportPowerBiContainer }
})
export default class PbiGreenfieldPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();
  public dictReports = new TupleDictionary<[ClientEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    // BRASIL
    this.dictReports.set([ClientEnum.GM, CountryEnum.Brasil], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '062010e4-99fd-430a-8b16-8ecce9bf311e' });

    //  PERU
    this.dictReports.set([ClientEnum.GM, CountryEnum.Peru], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '23aa639c-d9d4-477b-8c22-5f48e8dd81f7' });

    // ARGENTINA
    this.dictReports.set([ClientEnum.GM, CountryEnum.Argentina], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'b3ccc355-20d3-4419-a77a-7e6104f192ec' });

    // CHILE
    this.dictReports.set([ClientEnum.GM, CountryEnum.Chile], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'beb7246c-359d-408f-97a0-be6eca98ad1d' });

    // EQUADOR
    this.dictReports.set([ClientEnum.GM, CountryEnum.Equador], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '1cc248fe-c4cf-48bb-9574-e11b7ee6226b' });

    // COLOMBIA
    this.dictReports.set([ClientEnum.GM, CountryEnum.Colombia], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'f45e5207-6c30-4303-a300-bb3f7780821b' });
    this.dictReports.set([ClientEnum.Hyundai, CountryEnum.Colombia], { brand: 'Hyundai', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'a5862d57-7d2f-4f3f-b992-c7e28e190be7' });

    this.crrReport = this.dictReports.get([this.client.id, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Dealer Evaluation`);
  }
}
